import React from "react";
import EntityList from "../../EntityList/EntityList";
import { CONTROLS_POSITION } from "../../../Common/constants";
import styled, { withTheme } from "styled-components";
import { Link } from "react-router-dom";
import { getPercentage } from "../../../Common/utils";
import moment from "moment/moment";

function customEntityToListValuesMapper({ entities }) {
  return entities.map(originalEntity => {
    const entity = { ...originalEntity };
    entity.tax = originalEntity.tax ? getPercentage(originalEntity.tax / 100) : 0;
    entity.ibanOk = originalEntity.ibanOk ? "OK" : "KO";
    entity.updated =
      originalEntity.updated && moment(originalEntity.updated).format("YYYY-MM-DD HH:mm");
    return entity;
  });
}

const StyledCellLink = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  margin: 0 12px 0 0;
  text-align: center;
  font-size: 14px;
`;

const StyledNumContractsCell = styled(StyledCellLink)`
  cursor: ${props => (props.active ? "pointer" : "auto")};
  text-decoration: ${props => (props.active ? "underline" : "none")};
`;

const StyledIdNumberCell = styled(StyledCellLink)`
  cursor: pointer;
  text-decoration: underline;
`;

class ClientsList extends React.Component {
  componentDidMount() {}

  componentWillUnmount() {}

  numContractsCell = ({ field, entity }) => {
    const fieldName = field && field.fieldName;
    const value = entity && entity[fieldName];
    const active = Boolean(value);
    if (active) {
      return (
        <Link
          style={{ color: this.props.theme.regularTextColor }}
          target="_blank"
          to={`/crm/contracts?client=${entity.id}`}>
          <StyledNumContractsCell active={active}>{value}</StyledNumContractsCell>
        </Link>
      );
    } else {
      return <StyledNumContractsCell active={active}>{value}</StyledNumContractsCell>;
    }
  };

  idNumberCell = ({ field, entity }) => {
    const fieldName = field && field.fieldName;
    const value = entity && entity[fieldName];
    return (
      <Link
        style={{ color: this.props.theme.regularTextColor }}
        target="_blank"
        to={`/crm/clients/${entity.id}`}>
        <StyledIdNumberCell>{value}</StyledIdNumberCell>
      </Link>
    );
  };

  render() {
    const {
      name,
      entityName,
      validation,
      fields,
      renderers,
      sorting,
      allowClone,
      allowDelete,
      allowExport,
      exportFileName,
      reorder,
      filterFields,
      showTotalRecords,
    } = this.props.config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      success,
    } = this.props;
    renderers.numContracts = this.numContractsCell;
    renderers.id = this.idNumberCell;
    return (
      <EntityList
        filterFields={filterFields}
        loading={loading}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        customEntityToListValuesMapper={customEntityToListValuesMapper}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        currentLocale={this.props.config.locale}
        success={success}
        sorting={sorting}
        allowClone={allowClone}
        allowDelete={allowDelete}
        allowExport={allowExport}
        exportFileName={exportFileName}
        reorder={reorder}
        maxColumnWidth={220}
        horizontalScroll
        controlsPosition={CONTROLS_POSITION.TOP}
        showTotalRecords={showTotalRecords}
        headerLink="/v6/ng/crm/clients?clearFilters=true"
        hasFilters
      />
    );
  }
}

ClientsList.propTypes = {};

ClientsList.defaultProps = {};

export default withTheme(ClientsList);
